<template>
<!--    <v-card class="overflow-hidden">-->
<!--        <v-app-bar-->
<!--                absolute-->
<!--                color="white"-->
<!--                elevate-on-scroll-->
<!--                scroll-target="#scrolling-techniques-7"-->
<!--        >-->
<!--            <v-app-bar-nav-icon></v-app-bar-nav-icon>-->

<!--            <v-toolbar-title>Title</v-toolbar-title>-->

<!--            <v-spacer></v-spacer>-->

<!--            <v-btn icon>-->
<!--                <v-icon>mdi-magnify</v-icon>-->
<!--            </v-btn>-->

<!--            <v-btn icon>-->
<!--                <v-icon>mdi-heart</v-icon>-->
<!--            </v-btn>-->

<!--            <v-btn icon>-->
<!--                <v-icon>mdi-dots-vertical</v-icon>-->
<!--            </v-btn>-->
<!--        </v-app-bar>-->
<!--    </v-card>-->
</template>

<script>
    export default {
        name: "TopNavigation.vue"
    }
</script>
